//Fecha	DNI	Nombre	Apellido	Email	Telefono	Localidad y Prov.
// aceptaTerminos: true
// apellido: "FERRAND"
// captchaValidado: true
// dni: "26230461"
// dniValidado: false
// email: "COBERTORESTANGO@GMAIL.COM"
// emailValidado: true
// estrategiaId: 0
// fecha: "2020-11-04"
// id: 530
// ip: "181.46.240.125"
// localidad: null
// nombre: "HUGO"
// prefijo: "11"
// provincia: null
// score: 0
// scoreValidado: false
// smsValidado: true
// telefono: "38346947"

export function exportTableToCSV(leads, filename) {
    let csv = [];
    const csvHeader =
        "Fecha,DNI,Nombre,Apellido,Email,Telefono,Localidad,Provincia,DNI-Validado,Email-Validado,SMS-Validado";
    csv[0] = csvHeader;

    leads.forEach((lead) => {
        let row = [];
        const {
            fecha,
            dni,
            nombre,
            apellido,
            email,
            prefijo,
            telefono,
            localidad,
            provincia,
            dniValidado,
            emailValidado,
            smsValidado,
        } = lead;

        row.push([
            fecha || "---",
            dni || "---",
            nombre || "---",
            apellido || "---",
            email || "---",
            `${prefijo || "---"} ${telefono || "---"}`,
            localidad ? localidad.descripcion : "---",
            provincia ? provincia.descripcion : "---",
            dniValidado ? "Si" : "No",
            emailValidado ? "Si" : "No",
            smsValidado ? "Si" : "No",
        ]);

        csv.push(row.join(","));
    });

    downloadCSV(csv.join("\n"), filename);
}

function downloadCSV(csv, filename) {
    let csvFile;
    let downloadLink;

    // CSV file
    csvFile = new Blob([csv], { type: "text/csv" });

    // Download link
    downloadLink = document.createElement("a");

    // File name
    downloadLink.download = filename;

    // Create a link to the file
    downloadLink.href = window.URL.createObjectURL(csvFile);

    // Hide download link
    downloadLink.style.display = "none";

    // Add the link to DOM
    document.body.appendChild(downloadLink);

    // Click download link
    downloadLink.click();

    downloadLink.remove();
}



// WEBPACK FOOTER //
// ./src/helpers/CSVhelpers.js